import { css, keyframes } from '@emotion/react';
import { theme } from '../../theme/theme';

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

/** 뷰포트 전체를 덮는 반투명 백드롭. 우측 정렬로 패널을 오른쪽에 붙인다. */
export const backdropStyle = css`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  background: rgba(17, 24, 39, 0.35);
`;

/** 오른쪽에서 슬라이드로 나오는 패널. */
export const panelStyle = (width: number) => css`
  width: min(${width}px, 92vw);
  height: 100%;
  overflow-y: auto;
  background: ${theme.color.bg};
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);
  animation: ${slideIn} 0.22s ease-out;
`;
